import React from 'react';
import { connect } from 'react-redux';
import { toPlainObject, isEmpty } from 'lodash';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, STATIC_ROOT } from '../../../constants';
import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';
import { sendInvitations } from '../../../services/sponsorship/actions';

import { copy } from '../../../utils/copyToClipboardUtils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import {
    FormComponent,
    EmailInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import { LoadingComponent } from '../../loading/LoadingComponent';
import SponsorshipHowItWorks from './SponsorshipHowItWorks';
import ButtonComponent from '../../button/ButtonComponent';
import SponsorshipBanner from './SponsorshipBanner';
import SvgComponent from '../../SvgComponent';

import './SponsorshipPage.scss';

const FORM_NAME = 'sponsorship-form';

export class SponsorshipPage extends React.Component {
    constructor(props) {
        super(props);
        this.successMessage = React.createRef();
        this.state = {
            nbFields: 3,
            nbInvitSend: 0,
            hasLeastOneGodsonIsRequired: false,
            hasMultipleSameEmail: false,
            copied: false
        };
    }

    componentDidUpdate(prevProps) {
        const { sendingInvitationsSucceeded } = this.props;

        if (
            sendingInvitationsSucceeded &&
            sendingInvitationsSucceeded !== prevProps.sendingInvitationsSucceeded
        ) {
            this.successMessage.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    showLoginModal = () => event => {
        const { isAuthed, showModal } = this.props;

        if (!isAuthed) {
            event.preventDefault();
            showModal(MODAL_TYPE_LOGIN);
            return false;
        }
    };

    renderGodsonInputs = nb => {
        const { i18n } = this.props;

        return new Array(nb)
            .fill(null)
            .map((u, i) => (
                <EmailInputFieldComponent
                    key={i}
                    name={`emailList[${i}]`}
                    label={convertHtmlToReactDomWithParams(i18n.LABEL_EMAIL, i + 1)}
                    placeholder={convertHtmlToReactDomWithParams(i18n.PLACEHOLDER_EMAIL, i + 1)}
                />
            ));
    };

    onAddFields = () => {
        this.setState(state => ({ nbFields: state.nbFields + 3 }));
    };
    resetFields = () => {
        this.setState({ nbFields: 3 });
    };

    onClickCopy = text => {
        copy(text);
        this.setState({ copied: true });
        setTimeout(() => {
            this.setState({ copied: false });
        }, 2000);
    };

    onSubmit = values => {
        const { user } = this.props;
        const { emailList = [] } = values;

        const emails = emailList.filter(e => !!e);
        if (emails.length > 0) {
            const hasMultipleSameEmail = emails.reduce(
                (acc, cur, index, all) => acc || all.indexOf(cur) !== index,
                false
            );
            this.setState({ hasMultipleSameEmail, hasLeastOneGodsonIsRequired: false });
            if (!hasMultipleSameEmail) {
                this.setState({ nbInvitSend: emailList.length });
                this.props.sendInvitations({ emailList: emails, username: user.username });
            }
        } else {
            this.setState({ hasLeastOneGodsonIsRequired: true });
        }
    };

    render() {
        const {
            i18n,
            isAuthed,
            user,
            sendingInvitations,
            sendingInvitationsSucceeded,
            sendingInvitationsFailed,
            errorMessage
        } = this.props;
        const {
            nbFields,
            nbInvitSend,
            copied,
            hasLeastOneGodsonIsRequired,
            hasMultipleSameEmail
        } = this.state;

        const sponsorLink = isAuthed && user ? `${CONTEXT_ROOT}/?peetvader=${user.username}` : '';

        return (
            <main className="conteneur conteneur-mobile" id="p-sponsorship">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.SPONSORSHIP_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>
                <p className="subtitle">{i18n.SUBTITLE}</p>

                <SponsorshipBanner />

                <h2 ref={this.successMessage}>{i18n.SPONSOR_TITLE}</h2>
                {sendingInvitationsSucceeded && !sendingInvitationsFailed && (
                    <p className="success">
                        {nbInvitSend > 1
                            ? i18n.SUCCESS_MESSAGE1_MULTIPLE
                            : i18n.SUCCESS_MESSAGE1_SINGLE}
                        <br />
                        {nbInvitSend > 1
                            ? i18n.SUCCESS_MESSAGE2_MULTIPLE
                            : i18n.SUCCESS_MESSAGE2_SINGLE}
                        <br />
                        {i18n.SUCCESS_MESSAGE3}
                    </p>
                )}
                <div className="sponsor-wrapper">
                    <h3>{i18n.SPONSOR_BLOC_TITLE}</h3>
                    <FormComponent
                        className="sponsorship-form"
                        form={FORM_NAME}
                        onSubmit={this.onSubmit}
                        requestSubmit={false}
                        errorSubmit={false}
                        hideButton>
                        {this.renderGodsonInputs(nbFields)}
                        <React.Fragment>
                            <div className="show-more">
                                <span className="more" onClick={this.onAddFields}>
                                    +
                                </span>
                                <span onClick={this.onAddFields}>{i18n.MORE_GODSONS}</span>
                            </div>
                        </React.Fragment>
                        <React.Fragment>
                            <div className="button-wrapper">
                                {sendingInvitations && <LoadingComponent />}
                                {hasLeastOneGodsonIsRequired && (
                                    <LegendFieldComponent classNameInputContainer="error message full">
                                        {i18n.ERROR_EMAIL_REQUIRED}
                                    </LegendFieldComponent>
                                )}
                                {hasMultipleSameEmail && (
                                    <LegendFieldComponent classNameInputContainer="error message full">
                                        {i18n.ERROR_SAME_EMAILS}
                                    </LegendFieldComponent>
                                )}
                                {sendingInvitationsFailed && (
                                    <LegendFieldComponent classNameInputContainer="error message full">
                                        {errorMessage}
                                    </LegendFieldComponent>
                                )}
                                {!sendingInvitations && (
                                    <ButtonComponent
                                        type="submit"
                                        color="main"
                                        text={i18n.SUBMIT_BUTTON}
                                        onClick={this.showLoginModal()}
                                    />
                                )}
                            </div>
                        </React.Fragment>
                    </FormComponent>
                </div>

                {isAuthed && user && (
                    <React.Fragment>
                        <div className="sponsor-wrapper">
                            <h3>{i18n.LINK_BLOC_TITLE}</h3>
                            <div className="link-wrapper">
                                <span>{sponsorLink}</span>
                                <ButtonComponent
                                    type="button"
                                    color="main"
                                    cssClass={copied ? 'copied' : ''}
                                    text={
                                        copied ? (
                                            <SvgComponent
                                                src={`${STATIC_ROOT}/check.svg`}
                                                width="30"
                                                height="22"
                                            />
                                        ) : (
                                            i18n.LINK_BUTTON_TEXT
                                        )
                                    }
                                    onClick={() => this.onClickCopy(sponsorLink)}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                )}

                <SponsorshipHowItWorks />
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.SPONSORSHIP,
        isAuthed: !isEmpty(state.authentication.token),
        user: toPlainObject(state.account.user),
        sendingInvitations: state.sponsorship.sendingInvitations,
        sendingInvitationsSucceeded: state.sponsorship.sendingInvitationsSucceeded,
        sendingInvitationsFailed: !isEmpty(state.sponsorship.sendingInvitationsFailed),
        errorMessage: state.sponsorship.sendingInvitationsFailed
    };
};

const mapDispatchtoProps = {
    showModal,
    sendInvitations
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchtoProps)(SponsorshipPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/sponsorship/SponsorshipPage.js